import React from "react";
import { JsonViewer } from "../../../../../common/components/json-viewer";

export const TransactionFlowView = ({ logs, onBack }: any) => {
  const grouped = logs.reduce((acc: any, log: any) => {
    (acc[log.action] = acc[log.action] || []).push(log);
    return acc;
  }, {});

  return (
    <div className="p-4 bg-white shadow rounded">

      <button
        onClick={onBack}
        className="mb-4 px-4 py-2 bg-blue-600 text-white rounded"
      >
        ← Back
      </button>

      <h2 className="text-xl font-bold mb-4">Transaction Flow</h2>

      {Object.keys(grouped).map((action) => (
        <div key={action} className="mb-6 border rounded shadow-sm">

          <div className="bg-gray-100 px-4 py-2 font-semibold text-lg">
            {action}
          </div>

          {grouped[action]
            .sort((a: any, b: any) =>
              new Date(a.timestamp).valueOf() -
              new Date(b.timestamp).valueOf()
            )
            .map((log: any) => (
              <div key={log._id} className="p-4 border-b">

                <div className="text-sm mb-2 text-gray-700">
                  <strong>Timestamp:</strong>{" "}
                  {new Date(log.timestamp).toLocaleString()}
                </div>

                <JsonViewer
                  data={log}
                  label={"Raw log (" + log.requestType + ")"}
                />
              </div>
            ))}
        </div>
      ))}
    </div>
  );
};
